import { types } from 'mobx-state-tree'
import { editableModel, InvoiceDetails, routes2 } from '@linqpal/models'
import RootStore from '../../../store/RootStore'
import { dispatcher, pathFactory, paths } from '../../links'
import projectsStore from '../../Projects/Store'
import { PURCHASE_TYPE, PurchaseTypes } from '@linqpal/models/src/dictionaries'
import { ApplicationType } from '@linqpal/models/src/dictionaries/applicationType'

const props = {
  projectCreationNotSupportedOnMobile: types.optional(types.boolean, false),
  groupedInvoiceProjectWarning: types.optional(types.boolean, false),
  selectPurchaseType: types.optional(types.boolean, false),
  chosenPurchaseType: types.maybeNull(
    types.enumeration(Object.values(PURCHASE_TYPE)),
  ),
  reconnectCreditBank: types.optional(types.boolean, false),
}

const volatile = () => ({
  resumeApplyingForLoan: () => {},
  startProjectFlow: () => {},
})

const actions = (self) => ({
  setStartProjectFlow(val) {
    self.startProjectFlow = val
  },
  setProjectCreationNotSupportedOnMobile(val) {
    self.projectCreationNotSupportedOnMobile = val
  },
  setResumeApplyingForLoan(val) {
    self.resumeApplyingForLoan = val
  },
  setSelectPurchaseType(value: boolean) {
    self.selectPurchaseType = value
  },
  setChosenPurchaseType(val: PurchaseTypes | null) {
    self.chosenPurchaseType = val
  },
  setGroupedInvoiceProjectWarning(value: boolean) {
    self.groupedInvoiceProjectWarning = value
  },
  setReconnectCreditBank(val: boolean) {
    self.reconnectCreditBank = val
  },
  projectNavigation(navigation: any, invoices: string, desktop: boolean) {
    if (RootStore.userStore.projectAdded) {
      navigation.navigate(paths.Console.Payables.SelectProject, {
        ids: invoices,
      })
    } else if (desktop) {
      navigation.navigate(paths.NewProject, { ids: invoices })
    } else {
      self.setProjectCreationNotSupportedOnMobile(true)
    }
  },
  singleInvoiceNavigation(invoice: any, sm: boolean, navigation: any) {
    if (invoice.project_id) self.resumeApplyingForLoan()
    else self.projectNavigation(navigation, invoice._id, sm)
  },
  groupedInvoiceProjectNavigation(sm: boolean, selectedInvoices?: any[]) {
    if (!selectedInvoices) return
    const desktopCheck = () => {
      if (sm || RootStore.userStore.projectAdded) {
        self.setGroupedInvoiceProjectWarning(true)
      } else {
        self.setProjectCreationNotSupportedOnMobile(true)
      }
    }
    if (projectsStore.isProjectMissingOnAllInvoices(selectedInvoices)) {
      desktopCheck()
    } else if (!projectsStore.areInvoicesFromSameProject(selectedInvoices)) {
      self.setGroupedInvoiceProjectWarning(true)
    } else {
      self.resumeApplyingForLoan()
    }
  },
  singleInvoicePurchaseTypeNavigation(invoice: any) {
    if (invoice.project_id) self.resumeApplyingForLoan()
    else self.setSelectPurchaseType(true)
  },
  purchaseTypeNavigation(invoice: any, selectedInvoices?: any[]) {
    if (selectedInvoices?.length) {
      if (projectsStore.isProjectMissingOnAllInvoices(selectedInvoices)) {
        self.setSelectPurchaseType(true)
      } else if (!projectsStore.areInvoicesFromSameProject(selectedInvoices)) {
        self.setGroupedInvoiceProjectWarning(true)
      } else {
        self.resumeApplyingForLoan()
      }
    } else if (invoice) {
      self.singleInvoicePurchaseTypeNavigation(invoice)
    }
  },
  takeUserToCreditApp: (
    setLoading: (arg: boolean) => void,
    route: any,
    navigation: any,
    invoice: any,
    invoiceIds?: string[],
  ) => {
    setLoading(true)
    const invoiceDetails = InvoiceDetails.create({
      invoiceId: invoiceIds ?? [invoice._id],
    })

    routes2.user
      .loanApplication(invoiceDetails)
      .then(() => {
        const params =
          route?.name !== paths.Console.Payables.Vendor
            ? { i: invoice?._id }
            : {}
        const action = dispatcher(pathFactory('CreditApplication'), params)
        navigation.replace(action.name, action.params)
        RootStore.userStore.fetchDocument(ApplicationType.Credit)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  },
})

const InvoiceActionsStoreModel = types.compose(
  'InvoiceActionStore',
  types.model(props).actions(actions).volatile(volatile),
  editableModel(),
)

const InvoiceActionsStore = InvoiceActionsStoreModel.create({})
export default InvoiceActionsStore
